import { getAdjustmentsById } from 'apis/project.api';
import { useQuery } from 'react-query';
import { useMemo } from 'react';

const useGetAdjustmentsById = (id, conds = {}) => {
  const { data: adjustmentData, ...rest } = useQuery(
    ['projectAdjustment', id],
    () => getAdjustmentsById(id),
    {
      ...conds,
    }
  );

  const adjustments = useMemo(() => adjustmentData?.data ?? [], [adjustmentData]);

  return {
    data: adjustments,
    ...rest,
  };
};

export default useGetAdjustmentsById;
